var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEcoWarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.58 3L54 6.55l2.59 3.58.91 1.26-.91 1.26L54 16.24l2.59 3.58.84 1.18h-3.7l-3.44-4.77 3.5-4.84-3.5-4.84L53.58 2h3.7l-.7 1zm2.15 3.58l2.09 2.89 1.41 2-1.41 2-2.09 2.89 2.09 2.89L62.16 21h3.7l-.05-.07-3.39-4.69 3.39-4.69.11-.16-.11-.16-3.39-4.68L65.72 2H62l-1.2 1.66-2.07 2.92zm12.09 0L74.11 2H70.4L69 3.94l-1.89 2.61L69 9.16l1.61 2.23L69 13.62l-1.89 2.61L69 18.85 70.55 21h3.7l-3.44-4.76 3.5-4.84-3.49-4.82zM36.74 16.85c-.73.143-1.45.327-2.16.55-10.91 3.54-16.81 15.52-13.17 26.78 3.64 11.26 15.44 17.52 26.36 14a20.18 20.18 0 009.89-7.06 20.94 20.94 0 01-20.92-34.27z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco_warm.4868675d.svg";
export { SvgF1ModeEcoWarm as ReactComponent };